// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const ric: CountryValidator<"CN", ParsedPersonId> =
  createValidator("cn.ric", 36);

export default ric;
export const compact = ric.compact;
export const format = ric.format;
export const validate = ric.validate;
export const generate = (): string =>
  ric.generate?.() ??
  (() => {
    throw new Error(
      "Validator cn.ric cannot generate values",
    );
  })();
export const parse = ric.parse;
